import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { Modal } from 'app-components';

import { ModalContextType } from '../../../contexts/modalContext';
import { ConditionalRendering } from '../../../components/common/conditional-rendering';
import { useStateCode } from '../../../hooks/useStateCode';
import CapitalizedButton from '../components/common/CapitalizedButton';
import { configs } from '../../../constants/configs/configs';

interface IModalProps extends ModalContextType {
    isMNSate: boolean,
    finEnrlHltDataKey: string
}

const LeftAlignContainer = styled.div<{ isLeftAlign: boolean }>`
    text-align: ${({ isLeftAlign }) => (isLeftAlign ? 'left' : 'right')};
`;

export default function PayNow({ finEnrlHltDataKey, closeModal }: IModalProps) {

    const { isPayNowWarningVisible, isPayNowFooterVisible } = useStateCode();
    const payUrl = configs.routes.PAYMENT_REDIRECT.replace(':finEnrlDataKey', finEnrlHltDataKey);
    const intl = useIntl();
    function onClose(e) {
        closeModal('payForEnrollment');
    }

    return (
        <Modal id="PayNowModal">
            <Modal.Header id="PayNowModalHeader" titleId="indportal.enrollments.completePaymentModal" onHide={onClose} />
            <Modal.Body id="PayNowModalBody">
                <p
                    dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'indportal.enrollments.proceedToPayment.content' }) }}>
                </p>
                <ConditionalRendering isTrue={isPayNowWarningVisible}>
                    <p> <FormattedMessage id="indportal.enrollments.proceedToPayment.content2" /></p>
                    <p><FormattedMessage id="indportal.enrollments.proceedToPayment.content3" /></p>
                </ConditionalRendering>
            </Modal.Body>
            <Modal.Controls>
                <LeftAlignContainer isLeftAlign={isPayNowWarningVisible}>
                    <CapitalizedButton
                        id="PayNowModalCancelButton"
                        onClickHandler={onClose}
                        variant="secondary"
                        labelId={isPayNowWarningVisible ? 'indportal.enrollments.proceedToPayment.cancel' : 'button.cancel'}
                    />
                    <a data-testid="viewBenefitDetailsBtn" id="viewBenefitDetailsBtn" target="_blank" rel="noopener noreferrer" href={payUrl}>
                        <CapitalizedButton
                            id="PayNowModalProceedButton"
                            labelId='indportal.enrollments.proceedToPayment'
                            onClickHandler={onClose}
                            leftMargin={true}
                        />
                    </a>
                    <ConditionalRendering isTrue={isPayNowFooterVisible}>
                        <p><FormattedMessage id="indportal.enrollments.proceedToPayment.content4" /></p>
                    </ConditionalRendering>
                </LeftAlignContainer>
            </Modal.Controls>
        </Modal>
    );
}